<chrome-picker *ngIf="isVisible" [control]="colorControl"></chrome-picker><div *ngIf="isVisible" class="overlay" (click)="overlayClick($event)" > </div>